import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import ReactNotify from 'react-notify';
import PromocjeService from "./PromocjeService";
import PromocjeForm from "./components/PromocjeForm";
import PromocjeTable from "./components/PromocjeTable";
import PromocjeSelectForm from "./components/PromocjeSelectForm";
import TrasyService from "../../trasyConfig/trasy/TrasyService";
import moment from "moment";
import DataAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import {TopAlertInformacja} from "../../../../componentsTopsa/alerty/TopAlerts";
import ScrollUtilities from "../../../../utilities/ScrollUtilities";

export default class PromocjeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasy: [],
            promocje: [],
            pokazFormularz: false,
            edytowana: null,
            szukana_trasa: null,
            szukana_dataOd: null,
            szukana_dataDo: null,
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.zamknijFormularz = this.zamknijFormularz.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()

        let now = moment();
        let obecny_rok = (now.year());
        let obecny_miesiac = (now.month()) + 1;

        let pierwszy_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-01')

        let ostatni_miesiaca = moment(obecny_rok + '-' + obecny_miesiac + '-' + moment(now).daysInMonth())

        this.setState({
            szukana_dataOd: DataAndTimeFormat.formatYYYYMMDD(pierwszy_miesiaca),
            szukana_dataDo: DataAndTimeFormat.formatYYYYMMDD(ostatni_miesiaca),
        })
        this.pobierzPromocje(null, DataAndTimeFormat.formatYYYYMMDD(pierwszy_miesiaca), DataAndTimeFormat.formatYYYYMMDD(ostatni_miesiaca));
    }

    pobierzPromocje(trasa, dataOd, dataDo) {
        PromocjeService.getPromocjeParams(dataOd, dataDo, trasa).then(function (response) {
            this.setState({promocje: response.data})
        }.bind(this))

    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({
                trasy: response.data.content,
            })
        }.bind(this))
    }


    onClickSzukaj(trasa, dataOd, dataDo) {
        this.setState({
            szukana_trasa: trasa,
            szukana_dataOd: dataOd,
            szukana_dataDo: dataDo,
        })

        this.pobierzPromocje(trasa, dataOd, dataDo)
    }

    zamknijFormularz() {
        this.setState({
            pokazFormularz: false,
            edytowana: null,
        })
    }

    onClickZapisz(obj, czyEdycja) {
        if (Boolean(czyEdycja)) {
            PromocjeService.editPromocja(this.state.edytowana.idPro, obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie edytowano promocję", "", 3000);
                    this.pobierzPromocje(this.state.szukana_trasa,this.state.szukana_dataOd, this.state.szukana_dataDo);
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas edycji promocji ", "", 3000);
                }
            }.bind(this))
        }
        else {
            PromocjeService.addPromocja(obj).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano promocję", "", 3000);
                    this.pobierzPromocje(this.state.szukana_trasa,this.state.szukana_dataOd, this.state.szukana_dataDo);
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania promocji ", "", 3000);
                }
            }.bind(this))
        }
        this.zamknijFormularz();
    }

    onClickEdytuj(obj) {
        ScrollUtilities.scrollToTop()
        this.setState({
            pokazFormularz: true,
            edytowana: obj,
        })
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc promocję: ' + obj.idPro)) {
            PromocjeService.deletePromocja(obj.idPro).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie usunięto promocję", "", 3000);
                    this.pobierzPromocje(this.state.szukana_trasa,this.state.szukana_dataOd, this.state.szukana_dataDo);
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas usuwania promocji ", "", 3000);
                }
            }.bind(this))
        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'ZarzadzanieBiletamiContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-biletami',
                                    text: 'Zarządzanie biletami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-biletami/promocje', text: 'Promocje'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={!this.state.pokazFormularz}>
                                <PromocjeSelectForm handleClickSzukaj={this.onClickSzukaj}
                                                    handleClickDodaj={() => this.setState({pokazFormularz: true})}
                                                    trasy={this.state.trasy}/>
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.pokazFormularz}>
                                <PromocjeForm
                                    trasy={this.state.trasy}
                                    handleZapisz={this.onClickZapisz}
                                    edytowana={this.state.edytowana}
                                    handleAnuluj={this.zamknijFormularz}
                                />
                            </TopIf>
                        </Col>
                        <Col xs={12}>
                            <PromocjeTable
                                data={this.state.promocje}
                                wlaczSzukanie={true}
                                handleEdytuj={this.onClickEdytuj}
                                handleUsun={this.onClickUsun}/>
                        </Col>
                        <Col xs={12}>
                            <TopAlertInformacja text={'Typ "dokładnie od do" oznacza, że klient może skorzystać z promocji tylko gdy wsiada w mieście początkowym i wysiada w mieście końcowym zdefiniowanym w promocji.'}/>
                            <TopAlertInformacja text={'Typ "na całym odcinku" oznacza, że klient może skorzystać z promocji wsiadając lub wysiadając w miejscowościach znajdujących się pomiędzy tymi, zdefiniowanymi w promocji.'}/>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/promocje/PromocjeContainer.js